import Wrapper from "../../Wrapper";

 const Acicommunicator = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>ACI Communicator</h3>
         </Wrapper>
         </>
     );
 }
 export default Acicommunicator;